import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncSiteFooter = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "footer" */
        /* webpackPreload: true */
        './SiteFooter'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
